export default __webpack_public_path__ + "media/images/smile-41068f17.png";